import { render, staticRenderFns } from "./CustomIndicators.vue?vue&type=template&id=6ef6d6b4&scoped=true&"
import script from "./CustomIndicators.vue?vue&type=script&lang=js&"
export * from "./CustomIndicators.vue?vue&type=script&lang=js&"
import style0 from "./CustomIndicators.vue?vue&type=style&index=0&id=6ef6d6b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6d6b4",
  null
  
)

export default component.exports